import api from './api';

// Transaction API endpoints
const TRANSACTION_BASE_URL = '/admin/wallet/transactions/';

export const getTransactions = async (params = {}) => {
  try {
    const response = await api.get(TRANSACTION_BASE_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching transactions:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch transactions');
  }
};

export const updateTransactionStatus = async (transactionId, status) => {
  try {
    const response = await api.put(`${TRANSACTION_BASE_URL}${transactionId}/status/`, { status });
    return response.data;
  } catch (error) {
    console.error('Error updating transaction status:', error);
    throw new Error(error.response?.data?.error || 'Failed to update transaction status');
  }
};

export const getTransaction = async (id) => {
  try {
    const response = await api.get(`${TRANSACTION_BASE_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching transaction:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch transaction');
  }
};


